import React from 'react';

const ResourceGroup = ({ group }) => {
    return (
        <div className="resource-group">
            <h4>{group.label}</h4>
            <ul>
                {group.values.map((resource, index) => {
                    return (
                        <li key={index}>
                            <a href="{resource.url}">{resource.text}</a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

ResourceGroup.propTypes = {
    group: React.PropTypes.object.isRequired
};

export default ResourceGroup;



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/resources/ResourceGroup.jsx
 **/